import React, { useState } from 'react'
import "./similartaskdetail.scss";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { API_URL } from '../../utils/ApiUrl';
import { useParams } from 'react-router-dom';
import CustomToast from '../CustomToast';
import { useWeb3React } from '@web3-react/core';

const Reportmodal = ({ showReport, handleCloseReport, setLoader }) => {

    const { account } = useWeb3React();
    
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { id } = useParams();

    const reportTaskHandle = async () => {
        const accessToken = localStorage.getItem("accessToken");
        if (account && accessToken) {
            try {
                setLoader(true);
                const res = await axios.post(
                    `${API_URL}tasks/${id}/report`,
                    {}, // if there's no body, send an empty object
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                setLoader(false);
                console.log(res, "res in reportTaskHandle");
                handleCloseReport();
                handleShow();
            } catch (error) {
                setLoader(false);
                console.log(error, "error");
                CustomToast.show('error', 'Error!', error)
            }
        } else {
            CustomToast.show('error', 'Error!', 'Connect your wallet!')
        }
    };

    return (
        <>
            <Modal show={showReport} onHide={handleCloseReport} className='reporttaskmodal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Report Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className='mainreportcontent'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                            <rect x="5" y="5" width="60" height="60" stroke="#013159" stroke-width="2" />
                            <rect x="34" y="18" width="2" height="28" fill="#013159" />
                            <rect x="34" y="49" width="2" height="3" fill="#013159" />
                        </svg>
                        <h3 className='reportuppertext'>Are you sure you want to report this task?</h3>
                        <p className='paraaaaaa'>This will flag the task for review. Report it only if it contains offensive, illegal, or misleading content.</p>
                        <div className='twicebuttonreport'>
                            <button className='cancle'>Cancel</button>
                            <button className='reportbtn'
                                onClick={() => {
                                    reportTaskHandle()
                                }}
                            >
                                Yes, Report It</button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            <Modal className='reporttaskmodal' centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className='mainreportcontent'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                            <rect x="5" y="5" width="60" height="60" stroke="#013159" stroke-width="2" />
                            <rect x="28.2035" y="49.8566" width="2" height="40.2235" transform="rotate(-135 28.2035 49.8566)" fill="#013159" />
                            <rect x="17" y="38.6251" width="2" height="15.43" transform="rotate(-45 17 38.6251)" fill="#013159" />
                        </svg>
                        <h4>Task Successfully Reported!</h4>
                        <p className='successpara'>Thanks for helping us keep the platform safe. This task will be reviewed, and action will be taken if necessary.</p>
                        <button className='okayy' onClick={() => handleClose()}>Okay</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Reportmodal